import React from 'react';
import { motion } from 'framer-motion';
import { Book, Zap, Home, Dumbbell, ShieldCheck, CreditCard, Users, Star, MapPin } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.complementodigital.shop/cart/40758159638657:1';
export function Hero() {
  return <section className="relative pt-12 pb-10 md:pt-32 md:pb-24 px-4 overflow-hidden flex flex-col items-center text-center" data-id="element-99">
      {/* Background image */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-100">
        <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=1600&q=70&auto=format&fit=crop" alt="Persona entrenando en casa con disciplina" loading="eager" fetchpriority="high" decoding="async" className="w-full h-full object-cover opacity-25" data-id="element-101" />
        <div className="absolute inset-0 bg-gradient-to-b from-zinc-950/70 via-zinc-950/85 to-zinc-950" data-id="element-102" />
      </div>

      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[400px] bg-brand-500/20 blur-[120px] rounded-full pointer-events-none" data-id="element-103" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="relative z-10 max-w-4xl mx-auto" data-id="element-104">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-zinc-900/80 backdrop-blur border border-zinc-800 mb-4" data-id="element-105">
          <span className="text-brand-500 font-bold text-xs md:text-sm" data-id="element-106">
            TODO TU CAMBIO FÍSICO Y MENTAL RESUELTO
          </span>
        </div>

        <h1 className="text-5xl md:text-8xl font-bebas leading-[0.9] mb-3 text-white" data-id="element-107">
          ENTRENA EN CASA™ <br data-id="element-108" />
          <span className="text-brand-500 text-glow" data-id="element-109">MEGAPACK</span>
        </h1>

        <motion.div animate={{
        rotate: [-2, 0, -2]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="inline-block bg-brand-500 text-white font-bebas text-xl md:text-3xl px-5 py-1.5 rounded-md mb-5 shadow-lg" data-id="element-110">
          6 + 3 TOMOS + BONUS
        </motion.div>

        <p className="text-sm md:text-xl text-zinc-200 max-w-2xl mx-auto mb-6 font-medium leading-relaxed" data-id="element-111">
          Tu sistema completo para transformar tu cuerpo desde casa: rutinas,
          hábitos, motivación, alimentación y disciplina. Sin gimnasio. Sin
          presión.
        </p>

        <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-112">
          {[{
          icon: Book,
          text: 'PDF Digital'
        }, {
          icon: Zap,
          text: 'Acceso Inmediato'
        }, {
          icon: Home,
          text: 'Desde Casa'
        }, {
          icon: Dumbbell,
          text: 'Principiante - Intermedio'
        }].map((badge, i) => <div key={i} className="flex items-center gap-1.5 bg-zinc-900/80 backdrop-blur border border-zinc-800 px-3 py-1.5 rounded-lg text-xs md:text-sm font-medium text-zinc-200" data-id="element-113">
              <badge.icon className="w-3.5 h-3.5 text-brand-500" data-id="element-114" />
              {badge.text}
            </div>)}
        </div>

        <motion.a href={CHECKOUT_URL} whileHover={{
        scale: 1.04
      }} whileTap={{
        scale: 0.96
      }} animate={{
        boxShadow: ['0 0 20px rgba(249,115,22,0.4)', '0 0 35px rgba(249,115,22,0.6)', '0 0 20px rgba(249,115,22,0.4)']
      }} transition={{
        boxShadow: {
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }
      }} className="inline-flex w-full sm:w-auto bg-brand-500 hover:bg-brand-600 text-white font-bebas text-xl md:text-3xl px-6 md:px-10 py-4 md:py-5 rounded-xl transition-colors items-center justify-center gap-2 mx-auto text-center" data-id="element-115">
          🔥 QUIERO TRANSFORMAR MI CUERPO
        </motion.a>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1.5 mt-5 text-[10px] md:text-sm text-zinc-400 font-medium" data-id="element-116">
          <div className="flex items-center gap-1" data-id="element-117">
            <ShieldCheck className="w-3 h-3 md:w-4 md:h-4 text-green-500" data-id="element-118" />{' '}
            Pago seguro
          </div>
          <div className="flex items-center gap-1" data-id="element-119">
            <CreditCard className="w-3 h-3 md:w-4 md:h-4 text-blue-400" data-id="element-120" />{' '}
            Mercado Pago
          </div>
          <div className="flex items-center gap-1" data-id="element-121">
            <Users className="w-3 h-3 md:w-4 md:h-4 text-brand-500" data-id="element-122" /> +500
            alumnos
          </div>
          <div className="flex items-center gap-1" data-id="element-123">
            <Star className="w-3 h-3 md:w-4 md:h-4 text-yellow-500 fill-yellow-500" data-id="element-124" />{' '}
            4.9 Rating
          </div>
          <div className="flex items-center gap-1" data-id="element-125">
            <MapPin className="w-3 h-3 md:w-4 md:h-4 text-zinc-300" data-id="element-126" /> Argentina
          </div>
        </div>
      </motion.div>
    </section>;
}